import apiClient from './client';

export const familyCurrenciesApi = {
  list: () => apiClient.get('/family_currencies'),
  peers: (id) => apiClient.get(`/family_currencies/${id}/peers`),
  recentMemos: (id) => apiClient.get(`/family_currencies/${id}/recent_memos`),
  transactions: (id, params = {}) =>
    apiClient.get(`/family_currencies/${id}/transactions`, { params }),
  transfer: (id, payload) =>
    apiClient.post(`/family_currencies/${id}/transfer`, payload),
  fuse: (id, payload = {}) =>
    apiClient.post(`/family_currencies/${id}/fuse`, payload),
  claimFusion: (operationId) =>
    apiClient.post(`/fusion_operations/${operationId}/claim`)
};

export default familyCurrenciesApi;
